import useIsMobile from '@/util/useIsMobile'
import { useRecoilValue } from 'recoil'
import { subDataState } from '@/util/states'

import { useApiCall } from 'src/hooks/useApiCall'
import BlogGrid from '../../components/Blog/BlogGrid'
import MuseNav from './navigation';


export async function getStaticProps() {
  return {
    props: {
      title: 'Interviews | Beyond the Pines',
      description: 'Interviews with the muses and creators of Beyond the Pines.',
    },
  }
}

export default function MuseInterviews() {
  const blogEntriesData = useApiCall({contentType: 'blogPost', order: '-fields.datePublished', options: { subscriptionRequired: true, match: "Interview" }})

  const isMobile = useIsMobile()
  const subData = useRecoilValue(subDataState)

  if (isMobile === undefined) return null
  if (subData === 'pending') return null

  return (
    <div className="w-full">
      <div className="dt:max-w-full mx-auto dt:px-6">
        <MuseNav />
        <BlogGrid blogEntriesData={blogEntriesData} isMobile={isMobile} subData={subData} />
      </div>
    </div>
  )
}
